export default (filename, data, type = 'text/csv') => {
    const element = document.createElement('a')
    const file = new Blob([data], {type})
    element.href = URL.createObjectURL(file)
    element.download = filename
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
}
